import React, { useRef, useEffect } from 'react';
import './SacredAbode.css';
import deityVideo from '../assets/videos/hero-video.mp4';

function SacredAbode({ onShowHistory }) {
  const videoRef = useRef(null);

  useEffect(() => {
    // Auto-play video when component mounts
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        // Auto-play was prevented, user interaction required
        console.log('Video autoplay prevented:', error);
      });
    }
  }, []);

  const handleVideoClick = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  };

  return (
    <section className="sacred-abode section-padding">
      <div className="container">
        <div className="abode-content">
          <div className="abode-image">
            <video
              ref={videoRef}
              className="abode-video"
              loop
              muted
              playsInline
              onClick={handleVideoClick}
            >
              <source src={deityVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="abode-text">
            <span className="section-label">About The Temple</span>
            <h2 className="section-title">
              <span className="title-part-1">The Sacred Abode of</span> <span className="title-part-2">Lord Sri Lakshmi Venkateswara</span>
            </h2>

            <p>
              GPR Grande Sri Lakshmi Venkateswara Temple stands as a testament to profound 
              devotion and Hindu mythology. Located in Chandapura, Bangalore South, our temple 
              serves as a sacred place of worship for devotees seeking blessings from 
              Lord Lakshmi Venkateswara, an incarnation of Vishnu.
            </p>

            <p>
              The temple trust was officially registered on 2nd August 2025, establishing 
              a foundation for spiritual service and community devotion. It is a place where 
              faith transcends time and tradition, inviting all to experience divine 
              serenity and spiritual fulfillment.
            </p>

            <div className="abode-features">
              <div className="feature-item">
                <i className="fas fa-gopuram"></i>
                <span>Ancient Heritage</span>
              </div>

              <div className="feature-item">
                <i className="fas fa-praying-hands"></i>
                <span>Sacred Rituals</span>
              </div>

              <div className="feature-item">
                <i className="fas fa-hand-holding-heart"></i>
                <span>Divine Blessings</span>
              </div>

              <div className="feature-item">
                <i className="fas fa-dove"></i>
                <span>Spiritual Peace</span>
              </div>
            </div>

            <button 
              className="btn btn-secondary"
              onClick={() => onShowHistory && onShowHistory()}
            >
              Temple History
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SacredAbode;